<script setup>
import GoogleTranslateSelect from "@google-translate-select/vue3";
import { ref, onMounted, onUnmounted } from 'vue';
import { useAuth } from '@/composables/useAuth';
import { convertLanguageToCode } from '@/constants/languages';

const { user } = useAuth();
const userLanguage = ref(convertLanguageToCode(user.value?.language) || 'ko'); // 기본값 ko

const isScriptLoaded = ref(false);

const handleLanguageChange = (event) => {
  if (event.detail?.language) {
    userLanguage.value = convertLanguageToCode(event.detail.language) || 'ko';
  }
};

function loadGoogleTranslateScript() {
  return new Promise((resolve, reject) => {
    if (window.google?.translate) {
      resolve();
      return;
    }

    const scriptId = 'google-translate-script';
    if (document.getElementById(scriptId)) {
      const check = setInterval(() => {
        if (window.google?.translate) {
          clearInterval(check);
          resolve();
        }
      }, 100);
      return;
    }

    window.googleTranslateElementInit = () => {
      resolve();
    };

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    script.async = true;
    script.onerror = () => reject(new Error('Google Translate script failed to load'));
    document.body.appendChild(script);
  });
}

onMounted(async () => {
  if (user.value?.language) {
    userLanguage.value = convertLanguageToCode(user.value.language) || 'ko';
  }

  document.addEventListener('setLanguage', handleLanguageChange);

  try {
    await loadGoogleTranslateScript();
    isScriptLoaded.value = true;
    console.log('Google Translate script loaded:', isScriptLoaded.value);
  } catch (error) {
    console.error('Google Translate script load error:', error);
  }
});

onUnmounted(() => {
  document.removeEventListener('setLanguage', handleLanguageChange);
});
</script>

<template>
  <div class="google-translate-container">
    <div v-if="!isScriptLoaded" class="loading-state">
      <div class="loading-text">로딩 중...</div>
    </div>
    <div v-else>
      <GoogleTranslateSelect
        :default-language-code="userLanguage"
        default-page-language-code="ko"
        :fetch-browser-language="false"
        dropdown-class-name="my-translate-dropdown"
      />
    </div>
  </div>
</template>

<style scoped>
.google-translate-container {
  width: 100%;
  min-height: 40px;
}

.loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  color: #666;
  font-size: 0.875rem;
}

.loading-text {
  text-align: center;
}
</style>
